module.exports = __webpack_public_path__ + "img/icon_add.854b59f0.svg";